import { ILocalizationData } from '../localization.data';

// Action Enums
export enum LocalizationActionsEnum {
  INIT_LOCALIZATION = '[Localization] INIT_LOCALIZATION',
  LOAD_LOCALIZATION = '[Localization] LOAD_LOCALIZATION',
  LOAD_LOCALIZATION_SUCCESS = '[Localization] LOAD_LOCALIZATION_SUCCESS',
  SET_LOCALE = '[Localization] SET_LOCALE',
  SET_LOCALE_SUCCESS = '[Localization] SET_LOCALE_SUCCESS',
}

export interface IILocale {
  locale: string;
}

// Actions
export interface InitLocalization {
  type: LocalizationActionsEnum.INIT_LOCALIZATION;
}

export interface LoadLocalization {
  type: LocalizationActionsEnum.LOAD_LOCALIZATION;
  payload: ILocalizationData;
}

export interface LoadLocalizationSuccess {
  type: LocalizationActionsEnum.LOAD_LOCALIZATION_SUCCESS;
  payload: ILocalizationData;
}

export interface SetLocale {
  type: LocalizationActionsEnum.SET_LOCALE;
  payload: IILocale;
}

export interface SetLocaleSuccess {
  type: LocalizationActionsEnum.SET_LOCALE_SUCCESS;
  payload: IILocale;
}

// Action Creators
export const initLocalization = (): InitLocalization => {
  return {
    type: LocalizationActionsEnum.INIT_LOCALIZATION,
  };
};

export const loadLocalization = (
  localizationData: ILocalizationData
): LoadLocalization => {
  return {
    type: LocalizationActionsEnum.LOAD_LOCALIZATION,
    payload: {
      ...localizationData,
    },
  };
};

export const loadLocalizationSuccess = (
  localizationData: ILocalizationData
): LoadLocalizationSuccess => {
  return {
    type: LocalizationActionsEnum.LOAD_LOCALIZATION_SUCCESS,
    payload: {
      ...localizationData,
    },
  };
};

export const setLocale = (locale: string): SetLocale => {
  return {
    type: LocalizationActionsEnum.SET_LOCALE,
    payload: {
      locale,
    },
  };
};

export const setLocaleSuccess = (locale: string): SetLocaleSuccess => {
  return {
    type: LocalizationActionsEnum.SET_LOCALE_SUCCESS,
    payload: {
      locale,
    },
  };
};
